import React from "react"
// we need to import directly from here due to circular references
import {FormattedMessage} from "react-intl-phraseapp"
import ErrorText from "@irati/ui/src/ErrorText"
import {ApolloState} from "../apolloStateInterface"
import {getErrorMessage} from "../../../lang/formatError"

export interface ErrorProps {
  errorMsg?: string
  apollo: ApolloState
}

const LoadingError: React.FC<ErrorProps> = (props) => {
  const {networkError} = props.apollo.error
  const {errorMsg = getErrorMessage(props.apollo.error)} = props

  return (
    <ErrorText {...props}>
      <FormattedMessage id={errorMsg} values={networkError.errorData} />
    </ErrorText>
  )
}

export default LoadingError
